/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import log, { type Event } from '@atlassian/jira-common-util-logging/src/log.tsx';

export const safeErrorWithoutCustomerData: (
	location: string,
	message: string,
	event?: Event,
) => Promise<void> = log.safeErrorWithoutCustomerData;
export const safeInfoWithoutCustomerData: (
	location: string,
	message: string,
	event?: Event,
) => Promise<void> = log.safeInfoWithoutCustomerData;

export type Options = {
	/** Retries */
	tentatives: number;
	timeout: number;
	shouldLogError: boolean;
};

export type BatchDetailsResponseType = {
	resources: {
		url: string;
		key: string;
		batchType: string;
		resourcesType: string;
		media?: string;
	};
	unparsedData: Map<string, string>;
	unparsedErrors: Map<string, string>;
};

export const MAX_RETRIES = 40;
export const DEFAULT_TIMEOUT = 500;
export const SHOULD_LOG_ERROR = true;
